import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "var(--neutral-500, #666666)",
        fillRule: "evenodd",
        d: "M7.6162 3.5322a1 1 0 0 1 1.0482-.5185l11 1.5c.5423.0903.9099.6015.823 1.1443l-4 12.5c-.0498 1.3115-.2436 1.5812-.5229.7276-.2794.1465-.6114 1.1527-.896 1.0166l-11.5-6.5a1 1 0 0 1-.4523-1.37zm1.4304 1.5727-3.6754 6.9424 9.3528 5.4731 3.6316-11.1973z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M8 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m-4 9c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m11 6c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2m5-14c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2",
        clipRule: "evenodd"
    }, "1")
], "AudienceGeo", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
